export const HelperTextComponent: React.FunctionComponent<any> = (
  props: any
) => {
  return <span>Maximum {props?.mlength} characters allowed</span>;
};
